export class PictureSearchModel {
  public url: string = null;

  static sample(): PictureSearchModel {
    const picture = new PictureSearchModel();

    picture.url = '/medias/?context=bWFzdGVyfGltYWdlc3wyNzU4N3xpbWFnZS9qcGVnfGltYWdlcy9o';

    return picture;
  }
}
